<template>
  <div class="w-full sm:w-56">
    <OButton
      v-if="!hideImages"
      pure
      class="w-full h-[200px] sm:h-[350px] rounded-lg sm:rounded-xl overflow-hidden"
      :class="{ 'cursor-default': hideActions }"
      @click="!hideActions ? openHoroscopeModal() : null"
    >
      <OImage :src="getHoroscopeImageUrl(selectedHoroscope || 'burc-sec')" class="w-full h-full" />
    </OButton>
    <OButton
      v-show="isResultPage && !hideActions"
      pure
      class="flex items-center justify-between w-full h-12 px-4 sm:px-8 text-lg font-semibold rounded-full border border-white text-white"
      @click="openHoroscopeModal"
    >
      {{ selectedHoroscope ? getHoroscopeName(selectedHoroscope) : 'Burç Seç' }}
      <OIcon icon="chevron-left-white" class="-rotate-90 w-4 h-4" />
    </OButton>
  </div>
</template>

<script>
import { defineComponent, ref, useRoute } from '@nuxtjs/composition-api';
import { OButton, OImage, OIcon } from '@/modules/common/components/ui';
import { getHoroscopeImageUrl, getHoroscopeName } from '@/modules/astrology/utils/astrologyUtils';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  components: {
    OButton,
    OImage,
    OIcon,
  },
  props: {
    horoscope: {
      type: String || null,
      required: false,
    },
    hideImages: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { openModal } = useModal();
    const selectedHoroscope = ref(props.horoscope || null);
    const route = useRoute();
    const horoscope1 = ref(route.value.params.pathMatch ? route.value.params.pathMatch.split('-')[0] : null);
    const horoscope2 = ref(route.value.params.pathMatch ? route.value.params.pathMatch.split('-')[1] : null);
    const isResultPage = horoscope1.value && horoscope2.value;

    const openHoroscopeModal = () => {
      openModal(import('~/modules/astrology/components/HoroscopeSelectionModal' /* webpackChunkName: "HoroscopeSelectionModal" */), {
        horoscope: selectedHoroscope.value,
        onSelect: (horoscope) => {
          selectedHoroscope.value = horoscope;
          emit('update', horoscope);
        },
      });
    };

    return {
      getHoroscopeImageUrl,
      getHoroscopeName,
      openHoroscopeModal,
      selectedHoroscope,
      isResultPage,
    };
  },
});
</script>
